const EMPTY = Object.freeze({});

const playerDuelDataRequestAction = () => {
    return (dispatch, getState, { componentDataEngine }) => {
        const state = getState();
        const {
            gumbo: {
                gameData: {
                    game: {
                        season
                    },
                    status: {
                        abstractGameCode
                    }
                },
                liveData: {
                    linescore: {
                        defense: {
                            pitcher: {
                                person: {
                                    id: pitcherId
                                }
                            }
                        },
                        offense: {
                            batter: {
                                person: {
                                    id: batterId
                                }
                            }
                        }
                    }
                }
            }
        } = state;
        if (abstractGameCode === 'F' || typeof batterId === 'undefined' || typeof pitcherId === 'undefined' || typeof season === 'undefined') {
            return Promise.resolve(EMPTY);
        }
        return componentDataEngine.fetchAndStore('playerDuel', { batterId, pitcherId, season });
    };
};

export default playerDuelDataRequestAction;
